import {ReactComponent as SecurePaymentIcon} from 'icons/secure-payment.svg'
import {useShowSecurePaymentMessage} from 'providers/EnvironmentProvider'

export const SecurePaymentMessage = () => {
  const showSecurePaymentMessage = useShowSecurePaymentMessage()
  let additionalClasses = ''

  if (!showSecurePaymentMessage) {
    additionalClasses = 'hidden'
  }

  return (
    <div
      className={`secure-payment-message flex gap-1 rounded-lg font-medium bg-[#D3FFD5] items-center py-2 px-4 text-[14px] ${additionalClasses}`}
    >
      <SecurePaymentIcon />
      <span className="text-[#1B440D]">Pay safely. We protect your information.</span>
    </div>
  )
}
